import template from './sectionTitle.html';
import './sectionTitle.scss';

let sectionTitleComponent = {
  restrict: 'E',
  bindings: {
    text: '@',
    isMobileApp: '<'
  },
  template
};

export default sectionTitleComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/sectionTitle/sectionTitle.component.js